<template>
    <div v-if="mediaType === 'image'" :class="format" :style="`background-image: url(${mediaUrl})`"></div>
    <video v-else autoplay muted loop id="myVideo" :class="format">
        <source :src="mediaUrl" type="video/mp4">
    </video>
</template>

<script>

export default {
    name:"MediaDisplay",

    props: {
        mediaUrl: {
            type: String,
            required: true 
        },

        mediaType: {
            type: String,
            required: true 
        },

        format: {
            type: String,
            required: true
        }
    },
}
</script>